export default __webpack_public_path__ + "static/media/close-icon.ffe4f7bf.svg";